<div class="quantity" *ngIf="params.qty"
  [ngClass]="{ quantity: params.qty < params.minimumOrderQty }"
  [matTooltip]="params.qty < params.minimumOrderQty
      ? 'Qty should be  equal or greater the Minimum Order Qty'
      : null "
>
  {{ params.qty }}
</div>
<div class="tag_name" *ngIf="params.name" [matTooltip]="params.name">
  {{ params.name}}
</div>

